import React from "react";

/**
 * What the GitHub App can and cannot do, shown immediately before someone
 * sends themselves to GitHub to authorize it.
 *
 * ⚠️ This is not decorative copy and it is not marketing. It renders directly
 * before a person grants an application access to their company's source
 * repositories, so it must match the permission screen GitHub is about to
 * display. It said "read-only access" until the review write-back added
 * `Pull requests: Write` — a mismatch here would be the worst possible place
 * for one (gotcha #43).
 *
 * Extracted from Onboarding when TeamlessPanel became a second surface that
 * can start the same authorization. Two copies of a claim like this drift, and
 * the drift is invisible until someone reads the two screens side by side.
 * One component, one claim.
 */
export default function GitHubPermissionsNote() {
  return (
    <div className="p-4 rounded-lg bg-rf-bg-tertiary border border-rf-border">
      <p className="text-xs text-rf-text-secondary leading-relaxed">
        Anthurium reads pull requests, repository contents, and metadata on the
        repos you select, and can{" "}
        <span className="text-rf-text-primary">request a reviewer</span> on a
        pull request. It never reads or writes your code. You can change the
        repository selection or uninstall at any time from GitHub.
      </p>
    </div>
  );
}
